import React from "react"

import { StringListInput } from "../../Input"


const renderStringList = (itemProps, inputProps, form, path) => {
  const componentProps = {
    form,
    path,
    itemProps,
    inputProps,
  }

  return (
    <StringListInput {...componentProps} />
  )
}

export default renderStringList
